"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var type_guard_1 = require("@webnuts/type-guard");
var react_1 = require("react");
// eslint-disable-next-line no-restricted-imports
var styled_components_1 = __importStar(require("styled-components"));
var border_1 = require("../../internal/css-types/border");
var font_1 = require("../../internal/css-types/font");
var margin_1 = require("../../internal/css-types/margin");
var padding_1 = require("../../internal/css-types/padding");
var factory_1 = require("../../internal/factory");
var factory_utils_1 = require("../../internal/factory-utils");
var BREAKPOINT_SETTINGS = {
    font: font_1.font,
    border: type_guard_1.optional(border_1.border),
    padding: type_guard_1.optional(padding_1.padding),
    margin: type_guard_1.optional(margin_1.margin)
};
var TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span'];
var SETTINGS = __assign({ tag: type_guard_1.optional(type_guard_1.enums(TAGS)) }, BREAKPOINT_SETTINGS);
exports.FactoryText = factory_1.factory({
    prefix: 'Text',
    settings: __assign(__assign({}, SETTINGS), { breakpoints: factory_utils_1.makeBreakpointSettings(BREAKPOINT_SETTINGS) }),
    component: function (settings, utils) {
        var _a;
        var Text = styled_components_1.default(((_a = settings.tag) !== null && _a !== void 0 ? _a : 'span'))(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      /* Remove default browser margin */\n      margin: 0;\n\n      ", "\n    "], ["\n      /* Remove default browser margin */\n      margin: 0;\n\n      ", "\n    "])), function (_a) {
            var $settings = _a.$settings;
            return utils.css.breakpoint($settings.breakpoints, $settings, function (settings) { return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            ", "\n            ", "\n            ", "\n            ", "\n          "], ["\n            ", "\n            ", "\n            ", "\n            ", "\n          "])), utils.css.font(settings.font), utils.css.border(settings.border), utils.css.padding(settings.padding), utils.css.margin(settings.margin)); });
        });
        Text.displayName = "Text(" + settings.tag + ")";
        return react_1.forwardRef(function (props, ref) { return (jsx_runtime_1.jsx(Text, __assign({ as: undefined, "$settings": settings, ref: ref }, props), void 0)); });
    }
}).FactoryText;
var templateObject_1, templateObject_2;
